module.exports = __webpack_public_path__ + "img/roomcard_level4.969bd858.png";